import { RoleModel } from "@/Administration/Models/Role/RoleModel";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./RoleInfoHeaderComponent.module.scss";

interface IRoleInfoHeaderComponentProps {
    roleDetails: RoleModel;
}

function RoleInfoHeaderComponent(props: Readonly<IRoleInfoHeaderComponentProps>): JSX.Element {
    const { getText } = useTranslation();

    return (
        <div className={styles.roleHeaderComponent} data-cy="roleInfoHeaderComponent">
            <div className={styles.title}>{props.roleDetails?.Name}</div>

            <div className={styles.fieldsSectionLayout}>
                <span className={styles.fieldName}>{getText("DescriptionDLabel")}</span>
                <span className={styles.fieldValue}>{props.roleDetails?.Description}</span>

                <span className={styles.fieldName}>{getText("PermissionsLabel")}</span>
                <span className={styles.fieldValue}>{props?.roleDetails?.PermissionIds?.length ?? 0}</span>

                <span className={styles.fieldName}>{getText("UsersLabel")}</span>
                <span className={styles.fieldValue}>{props.roleDetails?.UserIds?.length ?? 0}</span>
            </div>
        </div>
    );
}

export { RoleInfoHeaderComponent };
